module.exports = __webpack_public_path__ + "static/a-xx-004-art-e1a2cadfb14451ac516b5a06b3a9b79f.jpg";